const Equal = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H12C12.5523 2 13 1.55228 13 1C13 0.447715 12.5523 0 12 0H1ZM12 7.40918C12.5523 7.40918 13 6.96146 13 6.40918C13 5.85689 12.5523 5.40918 12 5.40918L1 5.40918C0.447715 5.40918 0 5.8569 0 6.40918C0 6.96147 0.447715 7.40918 1 7.40918L12 7.40918Z"
                fill="#1D1D1B"
            />
        </svg>
    )
}

export default Equal
